import { render, staticRenderFns } from "./CLoadingManifestShippingDetails.vue?vue&type=template&id=e29bd93a&scoped=true"
import script from "./CLoadingManifestShippingDetails.vue?vue&type=script&lang=ts"
export * from "./CLoadingManifestShippingDetails.vue?vue&type=script&lang=ts"
import style0 from "./CLoadingManifestShippingDetails.vue?vue&type=style&index=0&id=e29bd93a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29bd93a",
  null
  
)

export default component.exports